import gsap from "gsap";
import MotionPathPlugin from "gsap/MotionPathPlugin";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(MotionPathPlugin);
gsap.registerPlugin(ScrollTrigger);

export function initFadeIn() {
  const elements = document.querySelectorAll(".anim-fade-in");

  const observerOptions = {
    root: null, // Use the viewport as the container
    rootMargin: "0px",
    threshold: 0.15, // Trigger when 10% of the element is visible
  };

  const observerCallback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        gsap.to(entry.target, { opacity: 1, duration: 0.8 });
        observer.unobserve(entry.target); // Stop observing once the animation is done
      }
    });
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);

  elements.forEach((element) => {
    observer.observe(element);
  });

  console.log("Fade in animation initialized");
}

export function initSectionBgClassToggle() {
  const sections = document.querySelectorAll("[data-section-bg]");

  sections.forEach((section) => {
    const bgColor = section.getAttribute("data-section-bg");
    const className = `${bgColor}-section-active`;

    ScrollTrigger.create({
      trigger: section,
      start: "top top",
      end: "bottom top",
      onToggle: (self) => {
        if (self.isActive) {
          // Remove any existing background classes
          document.body.classList.remove(
            "dark-section-active",
            "white-section-active",
          );
          // Add the new background class
          document.body.classList.add(className);
        } else {
          document.body.classList.remove(className);
        }
      },
      markers: false, // Set to true if you want to see markers for debugging
    });
  });

  console.log("Section background class toggle initialized");
}
